<template lang="pug">
.page-subfooter__images(v-if="data && data?.images" )
	a.page-subfooter__left-link(
		v-for="(image, index) in data.images"
		:key="index"
		:href="image.href"
		target="blank")
		img.page-subfooter__image(
			:src="image?.src"
			:alt="image?.alt")

</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';

export default {

	mixins: [
		sourceMixin
	],

	data() {
		return {
			data: null
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
		}
	}
}

</script>